export const BYTES_IN_MEGABYTE = 1000000;